import React from 'react';
import { Provider } from 'react-redux';
import { store, persistor } from './config/store.config';
import { PersistGate } from 'redux-persist/integration/react';
import AppRoutes from './config/routes.config';
import { ChakraProvider } from '@chakra-ui/react';
import Loader from './components/loader.component';
// import { defaultSystem } from "@chakra-ui/react"
import { system } from './theme';
import { Toaster } from "../src/components/ui/toaster"


function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ChakraProvider value={system}>
          <AppRoutes />
          <Loader />
          <Toaster />
        </ChakraProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;